import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

const availableSliderControllers = [];

export default class extends Controller {
    connect() {
        availableSliderControllers.push(this);
        const element = this.element;
        const additionalConfig = element.dataset.splide ? JSON.parse(element.dataset.splide) : {};

        // Config https://splidejs.com/guides/options/
        const config = {
            lazyLoad: 'nearby',
            autoWidth: true,
            speed: 1000,
            autoplay: false,
            gap: '20px',
            ...additionalConfig,
        };

        this.splide = new Splide(element, config);
        this.splide.mount();

        if (element.dataset.gallery === "true") {
            this.thumbSplide = new Splide(element.querySelector(".thumbnails"), {
                lazyLoad: 'nearby',
                autoWidth: true,
                focus: 'center',
                speed: 1000,
                autoplay: false,
                gap: '2px',
                pagination: false,
                arrows: false,
            });
            this.thumbSplide.mount();

            this.thumbnails(0);
            this.splide.on('active', (activeSlide) => {
                this.thumbnails(activeSlide.index);
            });

            const observer = new MutationObserver(() => {
                this.slidesVisibleCount();
            });
            observer.observe(element.querySelector('.thumbnails .splide__slide'), {
                subtree: false,
                attributes: true,
            });

            this.slidesVisibleCount();
        }

        if (element.dataset.splide_main === "true") {
            const rootElement = this.splide.root;
            const parent = rootElement.parentElement;

            this.splide.on('pagination:updated', function (data, prev, curr) {
                const page = curr.page;
                parent.querySelectorAll('ul.splide__pagination').forEach((pagination) => {
                    if (pagination !== data.list) {
                        const list = pagination.querySelectorAll('li');
                        if (list.length > page) {
                            list[page].querySelector('button').click();
                        }
                    }
                });
            });

            this.splide.on('arrows:mounted', () => {
                const arrows = this.splide.Components.Arrows.arrows;
                arrows.next.addEventListener('click', () => {
                    parent.querySelectorAll('button.splide__arrow--next').forEach((button) => {
                        if (button !== arrows.next) {
                            button.click();
                        }
                    });
                });

                arrows.prev.addEventListener('click', () => {
                    parent.querySelectorAll('button.splide__arrow--prev').forEach((button) => {
                        if (button !== arrows.prev) {
                            button.click();
                        }
                    });
                });
            });
        }
    }

    thumbnails(index) {
        this.thumbSplide.go(index);
        this.thumbSplide.on('click', (activeSlide) => {
            this.splide.go(activeSlide.index);
        });
    }

    slidesVisibleCount() {
        const more = this.element.querySelector(".thumbnail-more");
        if (!more) {
            return;
        }
        let invisibleSlides = 0;
        let startCount = false;
        this.element.querySelectorAll(".thumbnails .thumbnail").forEach(function (elm) {
            if (elm.classList.contains("is-visible")) {
                startCount = true;
            } else if (startCount) {
                invisibleSlides++;
            }
        });
        more.querySelector("span").innerHTML = `+${invisibleSlides}`;
        if (invisibleSlides === 0) {
            more.style.display = "none";
        } else {
            more.style.display = "block";
        }
    }

    static refreshSliders() {
        for (const controller of availableSliderControllers) {
            controller.splide.destroy();
            controller.splide.mount();
        }
    }
}
